import React from 'react';

import InspirationsPage from '../components/InpirationsPage/InspirationsPage';

export default function Inspirations() {
    return (
        <div>
           <InspirationsPage /> 
        </div>
    )
}
